<template>
  <div class="home">
    <Header/>
    <Banner
      image="hero-canberra@2x.jpg"
      alt=""
    />
    <MembershipFormWrap
      formName="canberra"
    >
      <template slot="title">
        Nike Canberra is coming
      </template>
      <template slot="description">
        Become a member today and be the first to know about exclusive events, product launches, members-only offers and more. Nike Canberra opens April 18, 2019.
      </template>
    </MembershipFormWrap>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src

// Components
import Header from '@/components/Header.vue';
import Banner from '@/components/Banner.vue';
import MembershipFormWrap from '@/components/MembershipFormWrap.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'confirm',
  components: {
    Header,
    Banner,
    MembershipFormWrap,
    Footer,
  },
};
</script>
